/**
 * Stable `data-calendly-label` / `dataCalendlyLabel` values for left-nav items.
 * Used by nav config factories and tests so analytics ids are not duplicated as string literals.
 */
export const LEFT_NAV_CALENDLY_LABEL = Object.freeze({
  scheduling: 'scheduling',
  scheduledEvents: 'scheduled-events-link',
  contacts: 'contacts-link',
  workflows: 'workflows-link',
  routing: 'routing-link',
  landingPages: 'landing-pages-link',
  analytics: 'analytics-link',
  availability: 'default-schedule-link',
  integrations: 'integrations-link',
  admin: 'admin-link',
  orgDirectory: 'org-directory-link',
  recaps: 'recaps-link',
  sell: 'sell-link',
  ai: 'ai-link',
})
